import { useState } from "react";
import "./voip.scss";
import FeatureSection from "../../components/FeatureSection/FeatureSection.jsx";
import { FEATURE_SECTIONS } from "../../mocks/voipConfig.jsx";
import FormWrapper from "../../helpers/FormVoip/FormWrapper.jsx";

export default function Voip() {
  const [formOpen, setFormOpen] = useState(false);
  return (
    <div className="voip">
      <div className="groupBanner">
        <div className="groupBanner__banner">
          <h1>
            Business{" "}
            <span className="groupBanner__banner_violetBorder">VoIP</span> by{" "}
            <span className="groupBanner__banner_blueBorder">
              X-Cloud Solutions
            </span>
          </h1>
          <div className="groupBanner__banner__text">
            "Welcome to our VoIP services! With our solutions, you'll enjoy
            local voice presence wherever you need it. Whether you're running a
            <div className="groupBanner__banner__text__background">
              <div className="groupBanner__banner__text__background__blue"></div>
              <span>Cloud VoIP Center</span>
            </div>
            ,{" "}
            <div className="groupBanner__banner__text__background">
              <div className="groupBanner__banner__text__background__pink"></div>
              <span>Business Contact Center</span>
            </div>
            , or managing your
            <div className="groupBanner__banner__text__background">
              <div className="groupBanner__banner__text__background__green"></div>
              <span> Private VoIP Center</span>
            </div>
            , we've got you covered."
          </div>
        </div>
        <FeatureSection data={FEATURE_SECTIONS[0]} index={0} />
      </div>
      {FEATURE_SECTIONS.slice(1).map((section, index) => (
        <FeatureSection key={section.id} data={section} index={index + 1} />
      ))}
      <div className="storage">
        <h3>
          The exceptional storage performance has allowed us to streamline our
          services and ensure availability.
        </h3>
      </div>
      <div className="groupReasons">
        <div className="groupReasons__reasons">
          <div className="groupReasons__reasons__card">
            <h3>1</h3>
            <h4>Cost Efficient</h4>
            <p>
              With our solutions, you can increase the cost efficiency of your
              business thanks to uninterrupted application operation and quick
              response to any problems.
            </p>
          </div>
          <div className="groupReasons__reasons__card">
            <h3>2</h3>
            <h4>Rapidity</h4>
            <p>
              We understand that time is a valuable resource. That's why our
              highly available application creation service is designed to
              ensure maximum speed and efficiency.
            </p>
          </div>
          <div className="groupReasons__reasons__card">
            <h3>3</h3>
            <h4>Rapid Innovation</h4>
            <p>
              We provide the most reliable strategies and innovative solutions
              to ensure that your application remains available in all
              situations and at all times.
            </p>
          </div>
          <div className="groupReasons__reasons__card">
            <h3>4</h3>
            <h4>Quality</h4>
            <p>
              Our goal is to provide you with the highest level of service so
              that your business can continue to operate without interruption
              and with confidence in the reliability of our support.
            </p>
          </div>
        </div>
        <div className="groupReasons__buy">
          <h4>Buy now</h4>
          <p>
            Get in touch with our team and enjoy experience working with us.We
            are exited to know more about your project.
          </p>
          <button className="link" onClick={() => setFormOpen(true)}>
            By now
          </button>

          {formOpen && <FormWrapper onClose={() => setFormOpen(false)} />}
        </div>
      </div>
    </div>
  );
}
